const NotFound = () => {
  return (
    <div className="container">
      {/* <p>Não encontramos a rota informada.</p> */}
      <br />
      <br />
      <br />
    </div>
  );
};

export default NotFound;
